import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import momentHelper from 'scoreboard/components/moment-helper'
import template from './broadcast-alert-popup.hbs'

/**
 * @property {Alert} model
 * @property {string} model.message html string
 * @property {string} model.from sending user string
 *
 * @see AlertEventService.java#sendPopupAlerts
 */
var BroadcastAlertPopup = Backbone.View.extend({

	// #31277 is-alert-popup class tells the dialog/wizard code not to allow
	// this to be replaced when the wizard goes to the next step
	className: 'broadcast-alert-popup is-alert-popup',

	events: {
		'click .cancel' : 'close'
	},

	render: function() {
		const time = momentHelper.formatDateTime(new Date())
		const message = this.model.getMessage()
		const context = _.extend({},
			{created:time},
			this.model.attributes,
			{message})

		this.$el.empty().append(template(context))

		return this
	},

	close: function() {
		$.post(`api/alerts/read/${this.model.id}`)
		Backbone.trigger('decrement:unread')
		this.trigger('close')
	}
})

export default BroadcastAlertPopup

BroadcastAlertPopup.__filename__ = 'admin/alerts/broadcast-alert-popup.js'
